import { useId } from "react";

export type SliderProps = {
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
  onCommit?: (value: number) => void;
  label: string;
  showLabel?: boolean;
  valueText?: (value: number) => string;
  disabled?: boolean;
  className?: string;
};

export function Slider({ value, min = 0, max = 100, step = 1, onChange, onCommit, label, showLabel = false, valueText, disabled = false, className }: SliderProps) {
  const id = useId();
  const text = valueText ? valueText(value) : String(value);

  return (
    <div className={["fxmap-slider", className ?? ""].filter(Boolean).join(" ")}>
      {showLabel ? (
        <label className="fxmap-slider-label fxmap-muted" htmlFor={id}>
          {label}
        </label>
      ) : null}
      <input
        id={id}
        className="fxmap-slider-input"
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        aria-label={showLabel ? undefined : label}
        aria-valuetext={text}
        onChange={event => onChange(Number(event.target.value))}
        onPointerUp={event => onCommit?.(Number((event.target as HTMLInputElement).value))}
        onKeyUp={event => onCommit?.(Number((event.target as HTMLInputElement).value))}
      />
      <output className="fxmap-slider-value fxmap-tabular" htmlFor={id}>
        {text}
      </output>
    </div>
  );
}
